// src/features/admin/pages/AdminUserStatsPage.tsx
// Embeds the innoauth stats page.  GET /api/stats/users requires a Bearer
// token, and the innoauth SPA lives on another origin so it cannot read our
// localStorage — so it asks us for a token over postMessage and we answer.
//
// The token is never put in the iframe URL: that would leak it into the
// browser history, the referrer and nginx access logs.
import React from "react";
import { COLOR, FW } from "@/ui/tokens";
import { getAccessToken } from "@/lib/api";

const INNOAUTH_BASE = (import.meta.env.VITE_INNOAUTH_BASE ?? "https://auth.innoauth.com").replace(/\/+$/, "");
const SRC = `${INNOAUTH_BASE}/#/stats`;

const TOKEN_REQUEST = "BOOKTOX_STATS_TOKEN_REQUEST";
const TOKEN_REPLY = "BOOKTOX_STATS_TOKEN";

export default function AdminUserStatsPage() {
    React.useEffect(() => {
        const onMessage = (e: MessageEvent) => {
            // Only the stats page may ask, and the token goes back to that
            // exact origin — never to `*`.
            if (e.origin !== INNOAUTH_BASE) return;
            if ((e.data as any)?.type !== TOKEN_REQUEST) return;
            const source = e.source as Window | null;
            if (!source) return;
            source.postMessage({ type: TOKEN_REPLY, token: getAccessToken() }, INNOAUTH_BASE);
        };

        window.addEventListener("message", onMessage);
        return () => window.removeEventListener("message", onMessage);
    }, []);

    // Popup instead of <a target="_blank">: we need to keep a live opener
    // relationship so the new window can request a token the same way.
    const openInNewWindow = () => {
        window.open(SRC, "_blank");
    };

    return (
        // Outer div fills exactly the available space:
        // var(--app-lvh, 100vh) minus topbar (52px) minus main padding (28px × 2)
        <div style={{
            display: "flex",
            flexDirection: "column",
            gap: 12,
            height: "calc(var(--app-lvh, 100vh) - 52px - 56px)",
        }}>
            <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", flexShrink: 0 }}>
                <h2 style={{ margin: 0, fontSize: 20, fontWeight: FW.extraBold }}>사용자 통계</h2>
                <button
                    type="button"
                    onClick={openInNewWindow}
                    style={{
                        background: "none",
                        border: "none",
                        padding: 0,
                        cursor: "pointer",
                        fontSize: 12,
                        color: COLOR.textMuted,
                    }}
                >
                    새 창으로 열기 ↗
                </button>
            </div>

            <iframe
                src={SRC}
                title="사용자 통계 (innoauth)"
                style={{
                    flex: 1,
                    minHeight: 0,
                    width: "100%",
                    border: "none",
                    borderRadius: 10,
                    background: COLOR.bgLight,
                }}
            />
        </div>
    );
}
